var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerfilDeUsuario(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "perfil_de_usuario_pesta\\xF1a",
    "data-name": "perfil de usuario pesta\\xF1a",
    transform: "translate(-143.23 -911.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19020",
    "data-name": "Trazado 19020",
    d: "M162.38,922.216a4.944,4.944,0,0,1-5.86,4.857,5.368,5.368,0,0,1-4.02-5.1v-1.493a5.368,5.368,0,0,1,4.02-5.1,4.944,4.944,0,0,1,5.86,4.857Z",
    transform: "translate(3.291 1.575)",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1750",
    "data-name": "Elipse 1750",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(144.23 912.23)",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19021",
    "data-name": "Trazado 19021",
    d: "M148.16,934.43a12.3,12.3,0,0,1,22.131,0",
    transform: "translate(1.505 6.17)",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilDeUsuario);
export default __webpack_public_path__ + "static/media/perfil-de-usuario.5df94dbf56dacbce6dbb260dece75595.svg";
export { ForwardRef as ReactComponent };